/**
 * Muraasala API Service (Legacy Compatible)
 * This file re-exports the Unified API Service for backward compatibility
 * while also providing direct access to the new unified API
 */

import unifiedApi, {getAuthToken, getUser} from './unifiedApi';

// Re-export everything from unified API
export {getAuthToken, getUser};
export {unifiedApi};

// Default export for backward compatibility
export default unifiedApi;
